
import React, { useState } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    FormControl,
    FormLabel,
    FormControlLabel,
    Switch,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {LayoutFieldModel} from '../../models/models';


export const BooleanFieldComponent: React.FC<{
  layoutField: LayoutFieldModel,
  value: boolean,
  onChange: (value: boolean, layoutField: LayoutFieldModel) => void,
}> = ( {
  layoutField,
  value,
  onChange
}) => {

  const [error, setError] = useState(false);

  const handleChange = (event: any) => {
    const value=event.target.checked

    onChange(value, layoutField);
  }


  return (

      <FormControl
         fullWidth
         variant="filled">

         <FormControlLabel
            label={layoutField.ReferencedField_sys.Label_sys}
            control={
              <Switch
                 size="small"
                 checked={value}
                 onChange={(event) => handleChange(event)}
                 disabled={layoutField.AccessSetting_sys === 'read'}
              />
            }
            labelPlacement="top"
         />
       </FormControl>
    );

};
